module.exports = __webpack_public_path__ + "static/media/gobackblack.c8d7e68a.svg";